<template>
  <div>
    <div v-if="Object.keys(errors).length > 0" class="alert alert-danger">
      <p v-for="error in errors" class="errors">
        {{ error }}
      </p>
    </div>
    <div>
      <select :value="modification" name="modification" class="form-control" @change="handleChange">
        <option value="increase">
          Increase
        </option>
        <option value="decrease">
          Decrease
        </option>
        <option value="set">
          Set
        </option>
      </select>
      the participant's
      <span :class="{'has-error':errors.studyVariableId}">
        <select :value="studyVariableId" name="studyVariableId" class="form-control" @change="handleChange">
          <option value="">Select Variable</option>
          <option v-for="(variable, $id) in config.studyVariablesByType[varType]" :value="$id">{{ variable.name }}</option>
        </select>
      </span>
      variable value {{ modificationWord }}

      <span :class="{'has-error':errors.modificationType}">
        <select :value="modificationType" name="modificationType" class="form-control" @change="handleChange">
          <option value="" disabled>Select One</option>
          <option v-for="(display, $id) in availableModificationTypes" :value="$id">{{ display }}</option>
        </select>
      </span>

      <select
        v-if="modificationType === 'variable'"
        :value="modificationVariableId"
        name="modificationVariableId"
        class="form-control"
        @change="handleChange"
      >
        <option value="" selected="selected" disabled>
          Select Variable
        </option>
        <option v-for="(variable, value) in config.studyVariables" :value="value">
          {{ variable.name }}
        </option>
      </select>
      <span v-else-if="modificationType === 'value' || modificationType === 'percent'" :class="{'has-error':errors.modificationValue}">
        <input
          :value="modificationValue"
          class="form-control input-numeric"
          name="modificationValue"
          type="tel"
          @input="handleChange"
        >
        <span v-if="modificationType === 'percent'">%</span>
      </span>
    </div>

    <div v-if="showValueLimit">
      <label :class="{'has-error':errors.valueLimit}">
        <input :checked="hasValueLimit" type="checkbox" name="hasValueLimit" @change="handleChange">
        Do not allow the value to go
        <span v-if="modification === 'increase'">above</span>
        <span v-else-if="modification === 'decrease'">below</span>
      </label>
      <input
        :value="valueLimit"
        :disabled="!hasValueLimit"
        type="tel"
        class="form-control input-numeric"
        name="valueLimit"
        @input="handleChange"
      >
    </div>
    <div v-if="showDeltaLimit">
      <label :class="{'has-error':errors.deltaLimit}">
        <input :checked="hasDeltaLimit" type="checkbox" name="hasDeltaLimit" @change="handleChange">
        Do not change the value by more than
      </label>
      <input
        :value="deltaLimit"
        :disabled="!hasDeltaLimit"
        class="form-control input-numeric"
        name="deltaLimit"
        type="tel"
        @input="handleChange"
      >
    </div>
  </div>
</template>

<script>
  import BaseComponent from '@/EventLogic/components/BaseComponent.vue';
  import {enumValidator} from "@/EventLogic/util";

  export default {
    extends: BaseComponent,
    props: {
      id: String,
      studyVariableId: {
        // the variable whose value will be changed
        type: [Number, String]
      },

      modification: {
        type: String,
        validator: enumValidator(['set', 'increase', 'decrease']),
        default: 'increase'
      },
      modificationType: {
        type: String,
        validator: enumValidator(['value', 'percent', 'variable'])
      },
      modificationValue: {
        // Used by value and percent modification types
        type: Number
      },
      modificationVariableId: {
        // the variable whose value will be used when calculating the new value
        type: [Number, String]
      },

      // [ ] Do not allow the value to go above [     ]
      hasValueLimit: {
        type: Boolean,
        default: false
      },
      valueLimit: {
        type: Number
      },

      // [ ] Do not change the value by more than [     ]
      hasDeltaLimit: {
        type: Boolean,
        default: false
      },
      deltaLimit: {
        type: Number
      },
    },
    data: function() {
      return {
        availableModificationTypes: {
          value: 'Amount',
          percent: 'Percent',
          variable: 'Another variable\'s value'
        }
      };
    },
    computed: {
      varType() {
        switch(this.$options._componentTag) {
          case 'ModifyParticipantGoalVariable':
            return 'ParticipantGoalVariable';
            break;
          case 'ModifyPointBalanceVariable':
            return 'PointBalanceVariable';
            break;
        }
      },
      modificationWord() {
        if (this.modification === 'set') {
          return 'to'
        } else {
          return 'by'
        }
      },
      showValueLimit: function() {
        return (
                this.modificationType
                && this.modification !== 'set'
        );
      },
      showDeltaLimit: function() {
        return (
                this.modificationType
                && this.modification !== 'set'
                && this.modificationType !== 'value'
        );
      }
    },
    methods: {
      checkStudyVariableId: function() {
        if (!this.isNumber(this.studyVariableId)) {
          this.errors.studyVariableId = "Please select a Variable to modify.";
        }
      },
      checkModificationType: function() {
        switch (this.modificationType) {
          case 'variable':
            if (!this.isNumber(this.modificationVariableId)) {
              this.errors.modificationVariableId = "Please select a variable to modify by.";
            }
            break;
          case 'value':
            if (!this.isNumber(this.modificationValue)) {
              this.errors.modificationValue = "Please input an amount to modify the variable value.";
            }
            break;
          case 'percent':
            if (!this.isNumber(this.modificationValue)) {
              this.errors.modificationValue = "Please input a percent to modify the variable value.";
            }
            break;
          default:
            this.errors.modificationType = "Please select a modification type.";
        }
      },
      validate: function() {
        this.errors = {};
        this.checkStudyVariableId();
        this.checkModificationType();

        return Object.keys(this.errors).length === 0;
      }
    }
  };
</script>
